import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class MLGAFInfoService {
    static gpaSearchGAFInfos(searchText, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'searchGAFIInfoByName',
            [searchText, quoteID],
            additionalHeaders
        );
    }

    static gpaSearchGAFInfosByGpc(gpc, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'searchGAFIInfoByGpc',
            [gpc],
            additionalHeaders
        );
    }

    static gpaSelectEmployer(dto, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'selectEmployer',
            [dto, quoteID],
            additionalHeaders
        );
    }

    static gpaUpdateGAFInfo(dto, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'updateGAFInfo',
            [dto, quoteID],
            additionalHeaders
        );
    }

    static gpaCheckEligibility(cdfNumber, ssnOrAltId, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'checkEligibility',
            [cdfNumber, ssnOrAltId, quoteID],
            additionalHeaders
        );
    }

    static gpaCheckEligibilitySSNNameZip(lastName, zipCode, ssnOrAltId, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'checkEligibilitySSNNameZip',
            [lastName, zipCode, ssnOrAltId, quoteID],
            additionalHeaders
        );
    }

    static gpaSelectEmployee(employeeInfo, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'selectEmployee',
            [employeeInfo, quoteID],
            additionalHeaders
        );
    }

    static gpaResetEmployee(employeeInfo, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'resetEmployee',
            [employeeInfo, quoteID],
            additionalHeaders
        );
    }

    static gpaSearchFilteredGAFByGPC(gpc, quoteID, paypoint = '', additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'searchFilteredGAFByGPC',
            [gpc, quoteID, paypoint],
            additionalHeaders
        );
    }

    static gpaSearchGAFInfoForTypeahead(searchText, quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewaygaf'),
            'searchGAFInfoForTypeahead',
            [searchText, quoteID],
            additionalHeaders
        );
    }
}
